import "core-js";
import "regenerator-runtime/runtime";
import "./polyfills";
import "./classList";
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import appstore from './store';
import LazyLoad from 'vanilla-lazyload';
import GLightbox from 'glightbox';
import Navigation from './components/navigation';
import Home from './components/home';
import Newsletter from './components/newsletter';
import Unsubscribe from './components/unsubscribe';
import Peoples from './components/peoples';
import Expertise from './components/expertise';
import GlobalModal from './components/globalModal';
import ProjectImages from './components/projectImages';
import ProjectTestimonies from './components/projectTestimonies';
import LogosForm from './components/logosForm';
import ContactUsForm from './components/contactUsForm';
import Collapsable from './components/collapsable';
import ExpendableArticle from './components/expendableArticle';
import FeaturedStories from './components/featuredStories';
import DropdownNavigation from './components/dropdownNavigation';
import Hamburger from './components/hamburger';
import HideNavigation from './components/hideNavigation';
import Search from './components/search';
import Didomi from './components/didomi';
import A11y from './utils/a11y.js';
import Research from './components/research';
import oembedAddFrame from './components/oembedAddFrame';
import ProjectBrowser from './components/vue/home/ProjectBrowser.vue';
import ProjectList from './components/vue/projects/ProjectList.vue';
import RelatedProjectsList from './components/vue/projects/RelatedProjectsList.vue';
import ArticlesList from './components/vue/articles/ArticlesList.vue';
import VideosList from './components/vue/videos/VideosList.vue';
import ReportsList from './components/vue/reports/ReportsList.vue';
import EngagementsList from './components/vue/engagements/EngagementsList.vue';
import JobList from './components/vue/careers/JobList.vue';
import StoryPathsList from './components/vue/storyPaths/StoryPathsList.vue';
export default class Main {
    constructor() {
        const lazyLoadInstance = new LazyLoad({
            elements_selector: '.lazy',
            threshold: 0,
        });
        GLightbox({});
        window.cibbic.lazyLoadInstance = lazyLoadInstance;
        new Home();
        new Newsletter();
        new Unsubscribe();
        new Navigation();
        new ProjectImages();
        new ProjectTestimonies();
        new Collapsable();
        new ExpendableArticle();
        new FeaturedStories();
        new Peoples();
        new Expertise();
        new GlobalModal();
        new LogosForm();
        new ContactUsForm();
        new Hamburger();
        new DropdownNavigation();
        new HideNavigation();
        new Search();
        new Didomi();
        new A11y();
        new Research();
        // setExternalLink();
        oembedAddFrame();
        Vue.use(VueCookies);
        Vue.$cookies.config('7d', '/');
        // Vue Components
        if (document.getElementById('project-browser')) {
            new Vue({
                el: 'project-browser',
                components: {
                    ProjectBrowser
                },
                store: appstore
            });
        }
        if (document.getElementById('project-list')) {
            new Vue({
                el: 'project-list',
                components: {
                    ProjectList
                },
                store: appstore
            });
        }
        if (document.getElementById('articles-list')) {
            new Vue({
                el: 'articles-list',
                components: {
                    ArticlesList
                },
                store: appstore
            });
        }
        if (document.getElementById('videos-list')) {
            new Vue({
                el: 'videos-list',
                components: {
                    VideosList
                },
                store: appstore
            });
        }
        if (document.getElementById('reports-list')) {
            new Vue({
                el: 'reports-list',
                components: {
                    ReportsList
                },
                store: appstore
            });
        }
        if (document.getElementById('related-projects')) {
            new Vue({
                el: '#related-projects',
                components: {
                    RelatedProjectsList
                },
                store: appstore
            });
        }
        if (document.getElementById('engagements-list')) {
            new Vue({
                el: '#engagements-list',
                components: {
                    EngagementsList
                },
                store: appstore
            });
        }
        if (document.getElementById('jobs')) {
            new Vue({
                el: '#jobs',
                components: {
                    JobList
                },
                store: appstore
            });
        }
        if (document.getElementById('story-paths-list')) {
            new Vue({
                el: '#story-paths-list',
                components: {
                    StoryPathsList
                },
                store: appstore
            });
        }
    }
}
new Main();
